import { createStore, applyMiddleware } from "redux";

// importing middleware
import thunk from "redux-thunk";

//importing root reducer
import rootReducer from "../store/reducers";


const middleWares = [thunk];

export const store = createStore(
  rootReducer,
  applyMiddleware(...middleWares)
);
